<template>
  <div>
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
    <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

    <div v-if="dataLoaded">
        <fiche-container ref="FICHE_CONTAINER"
                         :fiche="selectedFiche"
                         :route="notifRoute"
                         :attribut="attribut"
                         :route-element="routeElement"
                         @back="back"
                         @selectItem="selectItem">
        </fiche-container>
    </div>
    <div v-for="(button, index) in extraButtons" :key="index">
      <loader-button class="ms-2"
                     :outlined="button.outlined"
                     @callback="button.callback()"
                     :label="button.label"
                     :disabled="button.disabled">
      </loader-button>
    </div>
    <section-container :dialogOpen="showWizard"
                       :section="sectionWizard"
                       @closeDialog="hideWizard">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent, markRaw, type PropType } from "vue";
  import LoadProgress from '@/framework/base/components/LoadProgress.vue';
  import {
    storeSession,
    storeAccountEntry,
    storeDelivery,
    storeEtablissement,
    storeManualBillingDocument,
    storeNotif,
    storeSupport,
    storeTransaction,
    storeUser
  } from '@/generated/stores';
  import { CiRouter } from '@/framework/base/helpers/NavHelper';
  import Route from '@/generated/classes/Route';
  import ModuleBase from '@/framework/base/components/ModuleBase';
  import FichePointagesExtend from '@/extend/fiches/FichePointagesExtend.vue';
  import SectionPointages from '@/custom/sections/SectionPointages.vue';
  import FicheManualBillingDocumentsExtend from '@/extend/fiches/FicheManualBillingDocumentsExtend.vue';
  import SectionManualBillingDocumentListExtend from '@/extend/sections/SectionManualBillingDocumentListExtend.vue';
  import FicheManualBillingDocumentExtend from '@/extend/fiches/FicheManualBillingDocumentExtend.vue';
  import SectionManualBillingDocumentExtend from '@/extend/sections/SectionManualBillingDocumentExtend.vue';
  import FicheChecksRecuExtend from '@/extend/fiches/FicheChecksRecuExtend.vue';
  import SectionCheckWaitedListExtend from '@/extend/sections/SectionCheckWaitedListExtend.vue';
  import SectionCheckReceivedListExtend from '@/extend/sections/SectionCheckReceivedListExtend.vue';
  import SectionCheckDeliveryListExtend from '@/extend/sections/SectionCheckDeliveryListExtend.vue';
  import FicheChecksEmisExtend from '@/extend/fiches/FicheChecksEmisExtend.vue';
  import SectionCheckProcessingListExtend from '@/extend/sections/SectionCheckProcessingListExtend.vue';
  import SectionCheckEmitedListExtend from '@/extend/sections/SectionCheckEmitedListExtend.vue';
  import SectionCheckPayedListExtend from '@/extend/sections/SectionCheckPayedListExtend.vue';
  import FichePrelevementEmisExtend from '@/extend/fiches/FichePrelevementEmisExtend.vue';
  import SectionPrelevementDeliveryListExtend from '@/extend/sections/SectionPrelevementDeliveryListExtend.vue';
  import SectionPrelevementDeliveryDetailExtend from '@/extend/sections/SectionPrelevementDeliveryDetailExtend.vue';
  import FicheCarteEmisExtend from '@/extend/fiches/FicheCarteEmisExtend.vue';
  import SectionCarteDeliveryListExtend from '@/extend/sections/SectionCarteDeliveryListExtend.vue';
  import SectionCarteEmittedListExtend from '@/extend/sections/SectionCarteEmittedListExtend.vue';
  import FicheVirementsRecuExtend from '@/extend/fiches/FicheVirementsRecuExtend.vue';
  import SectionVirementWaitedListExtend from '@/extend/sections/SectionVirementWaitedListExtend.vue';
  import SectionVirementReceivedListExtend from '@/extend/sections/SectionVirementReceivedListExtend.vue';
  import FicheVirementsEmisExtend from '@/extend/fiches/FicheVirementsEmisExtend.vue';
  import SectionVirementDeliveryListExtend from '@/extend/sections/SectionVirementDeliveryListExtend.vue';
  import SectionVirementDeliveryDetailExtend from '@/extend/sections/SectionVirementDeliveryDetailExtend.vue';
  import FicheCreditLimitsExtend from '@/extend/fiches/FicheCreditLimitsExtend.vue';
  import SectionCreditLimitList from '@/custom/sections/SectionCreditLimitList.vue';
  import FicheVirementSalarieExtend from '@/extend/fiches/FicheVirementSalarieExtend.vue';
  import SectionVirementSalarie from '@/custom/sections/SectionVirementSalarie.vue';
  import FicheVirementEtablissementExtend from '@/extend/fiches/FicheVirementEtablissementExtend.vue';
  import SectionVirementEtablissement from '@/custom/sections/SectionVirementEtablissement.vue';
  import FicheBanqueExtend from '@/extend/fiches/FicheBanqueExtend.vue';
  import SectionBankList from '@/custom/sections/SectionBankList.vue';
  import SectionBankDetail from '@/custom/sections/SectionBankDetail.vue';
  import FicheRapprochementExtend from '@/extend/fiches/FicheRapprochementExtend.vue';
  import SectionRapprochement from '@/custom/sections/SectionRapprochement.vue';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import { GenModule, RessourceGenModule } from '@/generated/ressources/generatedRessources';
  import Wizard from '@/extend/classes/Wizard';
  import Section from '@/framework/base/classes/Section';
  import SectionWizard from '@/framework/wizard/components/SectionWizard.vue';
  import Fiche from '@/framework/base/classes/Fiche';
  import { RouteElements } from '@/framework/base/classes/Section';
  import User from '@/generated/classes/User';
  import FicheContainerAbstract from "@/framework/base/components/FicheContainerAbstract.vue";

  export function ModuleComptaOpenFiche(route: Route | undefined): RouteElements {
    const section = new Section();
    const fiche = new Fiche();
    if (route && route.fiche) {
      switch (route.fiche) {
        case Fiches.POINTAGES: {
          fiche.component = FichePointagesExtend;
          fiche.type = 'user'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeUser.createNewUser();
            } else {
              fiche.data = storeUser.getUser(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.MANUAL_BILLING_DOCUMENTS: {
          fiche.component = FicheManualBillingDocumentsExtend;
          fiche.type = 'manualBillingDocument'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeManualBillingDocument.createNewManualBillingDocument();
            } else {
              fiche.data = storeManualBillingDocument.getManualBillingDocument(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.MANUAL_BILLING_DOCUMENT: {
          fiche.component = FicheManualBillingDocumentExtend;
          fiche.type = 'manualBillingDocument'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeManualBillingDocument.createNewManualBillingDocument();
            } else {
              fiche.data = storeManualBillingDocument.getManualBillingDocument(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CHECKS_RECU: {
          fiche.component = FicheChecksRecuExtend;
          fiche.type = 'transaction'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeTransaction.createNewTransaction();
            } else {
              fiche.data = storeTransaction.getTransaction(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CHECKS_EMIS: {
          fiche.component = FicheChecksEmisExtend;
          fiche.type = 'transaction'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeTransaction.createNewTransaction();
            } else {
              fiche.data = storeTransaction.getTransaction(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.PRELEVEMENT_EMIS: {
          fiche.component = FichePrelevementEmisExtend;
          fiche.type = 'delivery'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeDelivery.createNewDelivery();
            } else {
              fiche.data = storeDelivery.getDelivery(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CARTE_EMIS: {
          fiche.component = FicheCarteEmisExtend;
          fiche.type = 'transaction'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeTransaction.createNewTransaction();
            } else {
              fiche.data = storeTransaction.getTransaction(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.VIREMENTS_RECU: {
          fiche.component = FicheVirementsRecuExtend;
          fiche.type = 'transaction'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeTransaction.createNewTransaction();
            } else {
              fiche.data = storeTransaction.getTransaction(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.VIREMENTS_EMIS: {
          fiche.component = FicheVirementsEmisExtend;
          fiche.type = 'delivery'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeDelivery.createNewDelivery();
            } else {
              fiche.data = storeDelivery.getDelivery(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CREDIT_LIMITS: {
          fiche.component = FicheCreditLimitsExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.VIREMENT_SALARIE: {
          fiche.component = FicheVirementSalarieExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.VIREMENT_ETABLISSEMENT: {
          fiche.component = FicheVirementEtablissementExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.BANQUE: {
          fiche.component = FicheBanqueExtend;
          break;
        }
        case Fiches.RAPPROCHEMENT: {
          fiche.component = FicheRapprochementExtend;
          fiche.type = 'transaction'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeTransaction.createNewTransaction();
            } else {
              fiche.data = storeTransaction.getTransaction(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CONTAINER: {
          fiche.component = FicheContainerAbstract;
          fiche.type = 'user'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeUser.createNewUser();
            } else {
              fiche.data = storeUser.getUser(route.ficheObjId);
            }
          }
          break;
        }
      }
    } else {
      fiche.component = FicheVirementsRecuExtend;
      fiche.type = 'transaction'
      if (route && route.ficheObjId != null) {
        if (route.ficheObjId == 0) {
          fiche.data = storeTransaction.createNewTransaction();
        } else {
          fiche.data = storeTransaction.getTransaction(route.ficheObjId);
        }
      }
    }
    if (route && route.section && route.section != Sections.NONE) {
      switch (route.section) {
        case Sections.POINTAGES: {
          section.component = SectionPointages;
          section.type = 'user'
          if (route.sectionObjId == 0) {
            section.data = storeUser.createNewUser();
          } else {
            section.data = storeUser.getUser(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.MANUAL_BILLING_DOCUMENT_LIST: {
          section.component = SectionManualBillingDocumentListExtend;
          section.type = 'manualBillingDocument'
          if (route.sectionObjId == 0) {
            section.data = storeManualBillingDocument.createNewManualBillingDocument();
          } else {
            section.data = storeManualBillingDocument.getManualBillingDocument(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.MANUAL_BILLING_DOCUMENT: {
          section.component = SectionManualBillingDocumentExtend;
          section.type = 'manualBillingDocument'
          if (route.sectionObjId == 0) {
            section.data = storeManualBillingDocument.createNewManualBillingDocument();
          } else {
            section.data = storeManualBillingDocument.getManualBillingDocument(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CHECK_WAITED_LIST: {
          section.component = SectionCheckWaitedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CHECK_RECEIVED_LIST: {
          section.component = SectionCheckReceivedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CHECK_DELIVERY_LIST: {
          section.component = SectionCheckDeliveryListExtend;
          section.type = 'delivery'
          if (route.sectionObjId == 0) {
            section.data = storeDelivery.createNewDelivery();
          } else {
            section.data = storeDelivery.getDelivery(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CHECK_PROCESSING_LIST: {
          section.component = SectionCheckProcessingListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CHECK_EMITED_LIST: {
          section.component = SectionCheckEmitedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CHECK_PAYED_LIST: {
          section.component = SectionCheckPayedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.PRELEVEMENT_DELIVERY_LIST: {
          section.component = SectionPrelevementDeliveryListExtend;
          section.type = 'delivery'
          if (route.sectionObjId == 0) {
            section.data = storeDelivery.createNewDelivery();
          } else {
            section.data = storeDelivery.getDelivery(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.PRELEVEMENT_DELIVERY_DETAIL: {
          section.component = SectionPrelevementDeliveryDetailExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CARTE_DELIVERY_LIST: {
          section.component = SectionCarteDeliveryListExtend;
          section.type = 'delivery'
          if (route.sectionObjId == 0) {
            section.data = storeDelivery.createNewDelivery();
          } else {
            section.data = storeDelivery.getDelivery(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CARTE_EMITTED_LIST: {
          section.component = SectionCarteEmittedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VIREMENT_WAITED_LIST: {
          section.component = SectionVirementWaitedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VIREMENT_RECEIVED_LIST: {
          section.component = SectionVirementReceivedListExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VIREMENT_DELIVERY_LIST: {
          section.component = SectionVirementDeliveryListExtend;
          section.type = 'delivery'
          if (route.sectionObjId == 0) {
            section.data = storeDelivery.createNewDelivery();
          } else {
            section.data = storeDelivery.getDelivery(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VIREMENT_DELIVERY_DETAIL: {
          section.component = SectionVirementDeliveryDetailExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.CREDIT_LIMIT_LIST: {
          section.component = SectionCreditLimitList;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VIREMENT_SALARIE: {
          section.component = SectionVirementSalarie;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VIREMENT_ETABLISSEMENT: {
          section.component = SectionVirementEtablissement;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.BANK_LIST: {
          section.component = SectionBankList;
          section.showButton = true;
          break;
        }
        case Sections.BANK_DETAIL: {
          section.component = SectionBankDetail;
          section.showButton = true;
          break;
        }
        case Sections.RAPPROCHEMENT: {
          section.component = SectionRapprochement;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
      }
    }
    if (fiche && fiche.component) {
      fiche.component = markRaw(fiche.component);
    }
    if (section && section.component) {
      section.component = markRaw(section.component);
    }
    const res = new RouteElements();
    res.fiche = fiche;
    res.section = section;
    return res;
  }

  export default defineComponent({
    extends: ModuleBase,
    components: {
      LoadProgress,
    },

    props: {
    },

    created (): void {
      if (this.route) {
        this.notifRoute = this.route;
      }
      const session = storeSession.connectedUser;
      if (session) {
        const user = storeUser.getUser(session.id);
        if (user.modules.includes(Modules.COMPTA)) {
          this.wizardDone = true;
        }
      }
      if (!this.wizardDone) {
        Wizard.showWizard(Modules.COMPTA).then((res) => {
          if (res.id > 0) {
            this.wizard = res;
            this.showWizard = true;
          } else {
            User.acceptCgu(true);
            this.wizardDone = true;
          }
        })
      }
      this.loadStores();
    },

    data() {
      const attribut: unknown = undefined;
      const route = CiRouter.getRoute();
      return {
        wizard: new Wizard(),
        attribut,
        notifRoute: new Route(),
        route,
      }
    },

    computed: {
      ressource () {
        return RessourceGenModule(GenModule.MODULE_COMPTA);
      },
      sectionWizard (): Section {
        const section = new Section();
        section.component = SectionWizard;
        section.data = this.wizard;
        section.helper = true;
        return section;
      },

      storesLoaded (): boolean {
        return true;
      },

      dataLoaded (): boolean {
        const res = this.wizardDone && this.storesLoaded
        if (res && this.init) {
          this.setInit(false);
          if (!this.route) {
            this.selectItem(this.route);
          }
          CiRouter.setRouteChangedSelector(this.routeChanged);
        }
        return res;
      }
    },

    methods: {
      loadStores() : void{
        // Load and register events on used server classes
        storeAccountEntry.registerAccountEntry();
        storeDelivery.registerDelivery();
        storeEtablissement.registerEtablissement();
        storeManualBillingDocument.registerManualBillingDocument();
        storeNotif.registerNotif();
        storeSupport.registerSupport();
        storeTransaction.registerTransaction();
        storeUser.registerUser();
      },
      setInit(value: boolean) : void{
        this.init = value;
      },
      routeChanged (route: Route): void {
        this.selectItem(route);
      },
      selectItem(route: Route | undefined): void {
        const routeElement = ModuleComptaOpenFiche(route);
        this.routeElement = routeElement;
        this.selectedFiche = routeElement.fiche;
        this.selectedFiche.ressourceHeader = this.ressource;
        if (route) {
          this.notifRoute = route;
          if (route && route.attribut) {
            this.attribut = route.attribut;
          } else {
            this.attribut = undefined;
          }
          if (route.section && route.section != Sections.NONE) {
            this.lastShowSection = !this.lastShowSection;
            this.selectedFiche.showSection = this.lastShowSection;
          }
        }
        const index = this.lastSelectedFiche.findIndex(item => {
          return item.component === this.selectedFiche.component;
        })
        if (index >= 0) {
          this.lastRoutes.splice(index + 1)
          this.lastSelectedFiche.splice(index + 1)
        } else {
          this.lastRoutes.push(route);
          this.lastSelectedFiche.push(this.selectedFiche);
        }
      }
    }
  })
</script>
